export default __webpack_public_path__ + "static/media/digital_experience.f318e6cb.svg";